import axios from 'axios';
import { gameTypes } from './_actionTypes';
import { to, history} from '../_helpers';
import {alertActions} from './';

const fetchGames = () => async dispatch => {
    const res = await axios.get('/api/games');
    dispatch({type: gameTypes.FETCH_GAMES, payload: res.data});
}

const createGame = (gameStartTime, gameEndTime, arena, playerCost, goalieCost, maxPlayers, maxGoalies) => async dispatch => {
    dispatch({
        type: gameTypes.CREATE_GAME_REQUEST,
        payload: null
    });
    const [err, res] = await to(axios.post('/api/games',
        {gameStartTime, gameEndTime, arena, playerCost, goalieCost, maxPlayers, maxGoalies},
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ));

    if(res){
        dispatch({
            type: gameTypes.CREATE_GAME_SUCCESS,
            payload: res.data
        });
        dispatch(alertActions.success('Game Created!'));
        dispatch(fetchGames());
        history.push('/admin');
    }else{
        dispatch({
            type: gameTypes.CREATE_GAME_FAILURE,
            payload: err.response
        });
    }
}

const editGame = (gameId, gameStartTime, gameEndTime, arena, playerCost, goalieCost, maxPlayers, maxGoalies) => async dispatch => {
    dispatch({
        type: gameTypes.EDIT_GAME_REQUEST,
        payload: null
    });
    const [err, res] = await to(axios.put('/api/games',
        {gameId, gameStartTime, gameEndTime, arena, playerCost, goalieCost, maxPlayers, maxGoalies},
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ));

    if(res){
        dispatch({
            type: gameTypes.EDIT_GAME_SUCCESS,
            payload: res.data
        });
        dispatch(alertActions.success('Game Changed!'));
        dispatch(fetchGames());
        history.push('/admin');
    }else{
        dispatch({
            type: gameTypes.EDIT_GAME_FAILURE,
            payload: err.response
        });
    }
}

const deleteGame = (gameId) => async dispatch => {
    const [err, res] = await to(axios.delete(`/api/games/${gameId}`));
    if(res) {
        dispatch({
            type: gameTypes.DELETE_GAME_SUCCESS,
            payload: {gameId: gameId}
        });
        history.push('/admin');
    } else {
        dispatch(alertActions.error(err.response.data.error.details[0].message));
        dispatch({
            type: gameTypes.DELETE_GAME_FAILURE,
            payload: err.response
        });
    }
}

export const gameActions = {
    fetchGames, createGame, editGame, deleteGame
}


// WEBPACK FOOTER //
// ./src/actions/game.actions.js